import React, { Component } from "react";
import UpdateProjectdetail from "./updateprojectdetail";
import axios from "axios";
import { API_CANDIDATE } from "../../../../utils/config";
import Button from "@material-ui/core/Button";
import Popup from "../../../../common/popup";
import { isSingleDateFormat } from "../../../../common/dateFormat";
import DateFns from "date-fns";
/**
 * ProjectDetails Component for displaying the Project details.
 */
class ProfessionalDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addBtn: false,
      updateBtn: false,
      data: [],
      isOpen: false,
      deletePopupId :"",
      updateData: null,
      validid: false,
    };
    this.openAddForm = this.openAddForm.bind(this);
    this.closeAddForm = this.closeAddForm.bind(this);
    this.openUpdateForm = this.openUpdateForm.bind(this);
    this.closeUpdateForm = this.closeUpdateForm.bind(this);
    this.getData = this.getData.bind(this);
    this.deleteAward = this.deleteAward.bind(this);
    this.togglePopup = this.togglePopup.bind(this);
    // this.isSingleDateFormat = this.isSingleDateFormat.bind(this)
  }

  // open add form
  openAddForm() {
    this.setState({
      updateBtn: true,
      updateData: null,
    });
  }
// close add form
  closeAddForm() {
    this.setState({
      addBtn: false,
    });
  }
  // toggle delete popup model
  togglePopup(detail) {
    this.setState({
      isOpen: !this.state.isOpen,
      deletePopupId: detail
    });
  }

  // open update form
  openUpdateForm(detail) {
    this.setState({
      updateBtn: true,
      updateData: detail,
    });
  }
  // close update form
  closeUpdateForm() {
    this.setState({
      updateBtn: false,
    });
    this.getData();
  }

  componentDidMount() {
    this.getData();
  }


  // get candidate project details
  getData() {
    axios
      .get(`${API_CANDIDATE}/v1/api/can-project`, { withCredentials: true })
      .then((res) => {
        console.log(res);
        this.setState({
          data: res.data,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });

    console.log(...this.state.data);
  }

  // delete function 

  deleteAward(obj) {
    if (this.state.data === undefined) {
      return;
    }
  

    let body = {
      id: obj,
    };

    console.log(body);

    axios
      .delete(`${API_CANDIDATE}/v1/api/can-project`, {
        withCredentials: true,
        data: body,
      })
      .then((res) => {
        console.log(res);

        if (res.data.message) {
          this.getData();
          this.setState({
            isOpen: false,
          });
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  

  render() {
    console.log(this.state.updateData);
    const { addBtn, updateBtn, data } = this.state;

    return (
      <>
        {!addBtn && !updateBtn ? (
          <>
          

            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
              className="details-flex-main-div"
            >
              <div style={{ paddingTop: "20px", height: "60px" }}>
                <h5  style={{ fontWeight: 500,fontSize:"1.25rem" }}>Project Details</h5>
              </div>
              <Button
                onClick={this.openAddForm}
                type="submit"
                style={{
                  background: "green",
                  marginTop: "10px",
                  color: "white",
                }}
                className="btn login-button white-text"
              >
                ADD
              </Button>
            </div>
            <div style={{ marginTop: "10px" }}>
              {this.state.data.map((detail) => (
                <div
                  key={detail.id}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    background: "#FFE8",
                    marginBottom: "30px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      paddingLeft: "2rem",
                      paddingBottom: "15px",
                      width: "100%",
                      marginTop: "20px",
                      borderRadius: "15px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "1.5rem",
                      }}
                    >
                      <span style={{fontWeight: "500", fontSize:"0.875rem" , flexBasis: "12rem" }}>
                        Customer Name
                      </span>
                      <span style={{ fontWeight: "bold", width: "20px" }}>
                        :
                      </span>
                      <span className="nostyle" style={{  flex: 8,overflow:"hidden",fontWeight: "400", fontSize:"0.75rem"  }}>
                        {detail.customerName}
                      </span>
                    </div>
                    <div
                      style={{
                       
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "1.5rem",
                      }}
                    >
                      <span style={{ fontWeight: "500", fontSize:"0.875rem" ,  flexBasis: "12rem" }}>
                        Project Name
                      </span>
                      <span style={{ fontWeight: "bold", width: "20px" }}>
                        :
                      </span>
                      <span className="nostyle" style={{  flex: 8,overflow:"hidden",fontWeight: "400", fontSize:"0.75rem"  }}>
                        {detail.projectName}
                      </span>
                    </div>

                    <div
                      style={{
                       
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "1.5rem",
                      }}
                    >
                      <span style={{fontWeight: "500", fontSize:"0.875rem" , flexBasis: "12rem" }}>
                        Project Description
                      </span>
                      <span style={{ fontWeight: "bold", width: "20px" }}>
                        :
                      </span>
                      <span className="nostyle" style={{  flex: 8,overflow:"hidden",fontWeight: "400", fontSize:"0.75rem"  }}>
                        {detail.projectDescription}
                      </span>
                    </div>

                    <div
                      style={{
                     
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "1.5rem",
                      }}
                    >
                      <span style={{ fontWeight: "500", fontSize:"0.875rem" ,  flexBasis: "12rem" }}>
                        Role
                      </span>
                      <span style={{ fontWeight: "bold", width: "20px" }}>
                        :
                      </span>
                      <span className="nostyle" style={{  flex: 8,overflow:"hidden",fontWeight: "400", fontSize:"0.75rem"  }}>
                        {detail.role}
                      </span>
                    </div>

                    <div
                      style={{
                     
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "1.5rem",
                      }}
                    >
                      <span style={{fontWeight: "500", fontSize:"0.875rem" ,  flexBasis: "12rem" }}>
                        Responsibilities
                      </span>
                      <span style={{ fontWeight: "bold", width: "20px" }}>
                        :
                      </span>
                      <span className="nostyle" style={{  flex: 8,overflow:"hidden",fontWeight: "400", fontSize:"0.75rem"  }}>
                        {detail.responsibilities}
                      </span>
                    </div>
                    <div
                      style={{
                      
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "1.5rem",
                      }}
                    >
                      <span style={{ fontWeight: "500", fontSize:"0.875rem" ,  flexBasis: "12rem" }}>
                        Skill Set
                      </span>
                      <span style={{ fontWeight: "bold", width: "20px" }}>
                        :
                      </span>
                      <span className="nostyle" style={{  flex: 8,overflow:"hidden",fontWeight: "400", fontSize:"0.75rem"  }}>
                        {detail.skillSet}
                      </span>
                    </div>
                    <div
                      style={{
                       
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "1.5rem",
                      }}
                    >
                      <span style={{fontWeight: "500", fontSize:"0.875rem" ,  flexBasis: "12rem" }}>
                        From Date
                      </span>
                      <span style={{ fontWeight: "bold", width: "20px" }}>
                        :
                      </span>
                      <span className="nostyle" style={{  flex: 8,fontWeight: "400", fontSize:"0.75rem"  }}>
                    
                        {/* {detail.fromDate ? isSingleDateFormat(detail.fromDate):""} */}
                        { detail.fromDate ?
                             DateFns.format(
                              detail.fromDate,
                                "DD-MM-YYYY"
                              )
                            : ""}
                      </span>
                    </div>
                    <div
                      style={{
                      
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "1.5rem",
                      }}
                    >
                      <span style={{fontWeight: "500", fontSize:"0.875rem" ,  flexBasis: "12rem" }}>
                        To Date
                      </span>
                      <span style={{ fontWeight: "bold", width: "20px" }}>
                        :
                      </span>
                      <span className="nostyle" style={{  flex: 8,fontWeight: "400", fontSize:"0.75rem"  }}>
                      { detail.toDate ?
                             DateFns.format(
                              detail.toDate,
                                "DD-MM-YYYY"
                              )
                            : ""}
                      </span>
                    </div>
                    <div
                      style={{
                       
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "1.5rem",
                      }}
                    >
                      <span style={{ fontWeight: "500", fontSize:"0.875rem" ,  flexBasis: "12rem" }}>
                        Tools & Technologies
                      </span>
                      <span style={{ fontWeight: "bold", width: "20px" }}>
                        :
                      </span>
                      <span className="nostyle" style={{ flex: 8,overflow:"hidden",fontWeight: "400", fontSize:"0.75rem"  }}>
                        {detail.toolsAndTechnologies}
                      </span>
                    </div>
                    <div
                      style={{
                       
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "1.5rem",
                      }}
                    >
                      <span style={{ fontWeight: "500", fontSize:"0.875rem" ,  flexBasis: "12rem" }}>
                        Duration (Years)
                      </span>
                      <span style={{ fontWeight: "bold", width: "20px" }}>
                        :
                      </span>
                      <span className="nostyle" style={{  flex: 8,overflow:"hidden",fontWeight: "400", fontSize:"0.75rem"  }}>
                        {detail.duration}
                      </span>
                    </div>
                  </div>

                  <div>
                    <i
                      style={{ color: "green", marginRight: "10px" }}
                      className="material-icons pointer edit-btn"
                      onClick={() => this.openUpdateForm(detail)}
                    >
                      edit
                    </i>
                    <i
                      style={{ color: "red" }}
                      // style={{ marginLeft: "1230px", marginBottom: "-500px", color: "red" }}

                      className="material-icons pointer contact-delete-btn"
                      onClick={() => this.togglePopup(detail)}
                    >
                      delete
                    </i>
                  </div>
                  {this.state.isOpen && (
                    <Popup
                      isOpenModal={this.togglePopup}
                      isOnDelete={this.deleteAward}
                      detail={this.state.deletePopupId}
                    />
                  )}
                </div>
              ))}
            </div>
          </>
        ) : null}
        {updateBtn && (
          <UpdateProjectdetail
            updateDataProp={this.state.updateData}
            back={this.closeUpdateForm}
            data={data}
          />
        )}
      </>
    );
  }
}

export default ProfessionalDetails;



